import { j as m } from "./jsx-runtime.js";
import { createContext as d, useContext as p, useState as r, useEffect as o } from "react";
import { Metaframe as l, isIframe as M } from "@metapages/metapage";
const I = {
  inputs: {}
}, h = {}, j = d(h), x = d(I), C = () => p(j), W = () => p(x), y = (u) => {
  const [c, f] = r({
    inputs: {}
  }), [e, s] = r(void 0), [n, t] = r(c.inputs);
  return o(() => {
    let i = !1;
    const a = new l(), O = a.onInputs((b) => {
      t(b);
    });
    return M() ? (async () => (await a.connected(), i || s(a)))() : s(a), () => {
      i = !0, O(), a.dispose();
    };
  }, []), o(() => {
    e && f({
      metaframe: e,
      inputs: n,
      setOutputs: e == null ? void 0 : e.setOutputs
    });
  }, [n, e]), m.jsx(x.Provider, { value: c, children: u.children });
}, E = (u) => {
  const [c, f] = r({}), [e, s] = r(void 0);
  return o(() => {
    let n = !1;
    const t = new l();
    return M() ? (async () => (await t.connected(), n || s(t)))() : s(t), () => {
      n = !0, t.dispose();
    };
  }, []), o(() => {
    e && f({
      metaframe: e
    });
  }, [e]), m.jsx(j.Provider, { value: c, children: u.children });
};
export {
  j as M,
  y as W,
  x as a,
  W as b,
  E as c,
  C as u
};
//# sourceMappingURL=useMetaframe.js.map
